import { AllCustomerTableColumnKeys } from "./RowsAndColumnsConfig";

export const customerNameColumnOrder: Array<AllCustomerTableColumnKeys> = [
  "fillFirst",
  "customerNo",
];

export const customerInfoColumnOrder: Array<AllCustomerTableColumnKeys> = [
  "country",
  "salesRegion",
  "seller",
];
export const statInfoColumnOrder: Array<AllCustomerTableColumnKeys> = [
  "statNo",
  "statNVolume",
  "statRVolume",
];

export const sailingUnitSpecificColumnOrder: Array<AllCustomerTableColumnKeys> =
  ["sailingCat", "unitType", "customerVolume", "avgLength"];

export const currencyColumnOrder: Array<AllCustomerTableColumnKeys> = [
  "net",
  "gross",
];

export const noLabelGroupTertiaryOrder: Array<AllCustomerTableColumnKeys> = [
  "target",
  "fillLast",
];
